import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { Plan } from '../../__legacy__/modules/user/user.store';
import { WorkspaceRole } from '../../__legacy__/modules/workspaces/workspaces.store';
import { checkAll, IPermissionCheckResult } from '../permissions/permissionsHelpers';
import { ICurrentWorkspaceStore } from '../workspaces/currentWorkspace/CurrentWorkspace.store';

interface IAttachmentsPermissions {
  canRenameAttachment(): IPermissionCheckResult;
  canViewAttachments(): IPermissionCheckResult;
  canAddAttachments(): IPermissionCheckResult;
  canDeleteAttachments(): IPermissionCheckResult;
  canDownloadAttachments(): IPermissionCheckResult;
}

export const useAttachmentsPermissions = (): IAttachmentsPermissions => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const { t } = useTranslator();

  const canRenameAttachment = (): IPermissionCheckResult => {
    return checkAll([Plan.Admin, Plan.Training, Plan.Annotation], [WorkspaceRole.Manager, WorkspaceRole.Owner], currentWorkspaceStore.currentWorkspace, t);
  };

  const canViewAttachments = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Inactive],
      [WorkspaceRole.Manager, WorkspaceRole.Owner, WorkspaceRole.Trainer, WorkspaceRole.Developer],
      currentWorkspaceStore.currentWorkspace,
      t
    );
  };

  const canAddAttachments = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation],
      [WorkspaceRole.Manager, WorkspaceRole.Owner, WorkspaceRole.Trainer, WorkspaceRole.Developer],
      currentWorkspaceStore.currentWorkspace,
      t
    );
  };

  const canDeleteAttachments = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Inactive],
      [WorkspaceRole.Manager, WorkspaceRole.Owner],
      currentWorkspaceStore.currentWorkspace,
      t
    );
  };

  const canDownloadAttachments = (): IPermissionCheckResult => {
    return checkAll(
      [Plan.Admin, Plan.Training, Plan.Annotation, Plan.Inactive],
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer, WorkspaceRole.Collaborator, WorkspaceRole.Guest],
      currentWorkspaceStore.currentWorkspace,
      t
    );
  };

  return {
    canRenameAttachment,
    canViewAttachments,
    canAddAttachments,
    canDeleteAttachments,
    canDownloadAttachments,
  };
};
